import axios from 'axios';

export function fetchSettings(videoID, weblinkID, email) {
    try {
        const params = {
            vid: videoID,
            wid: weblinkID,
            email: email,
        };
        return axios.post('/campaign/video/get/settings', params, {
            headers: { 'Content-Type': 'application/json' },
        });
    } catch (ex) {
        console.log(ex);
    }
}
export function fetchVideoDimensions(video) {
    return {
        width: video.outerWidth(),
        height: video.outerHeight(),
        top: video.offset().top,
        left: 0
    }
}

export function executeFullScreen(store) {
    const iconFullScreenActive = $("#fullscreen-active");
    const iconFullScreenInactive = $("#fullscreen-inactive");
    const bodyID = $('#bodyID');
    const videoOrientation = $('#video-orientation');
    const hasFrame = store.getHasFrame;
    let isIOS = false;
    if (window.location !== window.parent.location) {
        // The page is in an iFrames
        console.log("The page is in an iFrame");
        isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    }
    if (isIOS) {
        window.open(window.location.href, '_blank', 'noopener, noreferrer');
    } else {
        if (store.getFullScreen) {
            iconFullScreenActive.show();
            iconFullScreenInactive.hide();

            try {
                if (document.fullscreenElement) {
                    if (document.exitFullscreen)
                        document.exitFullscreen().catch(err => Promise.resolve(err));
                }else if (document.webkitFullscreenElement) {
                    if (document.webkitExitFullscreen)
                        document.webkitExitFullscreen();
                }else if (document.mozFullScreenElement) {
                    if (document.mozCancelFullScreen)
                        document.mozCancelFullScreen();
                }else if (document.msFullscreenElement) {
                    if (document.msExitFullscreen)
                        document.msExitFullscreen();
                }
                store.setFullScreen(false);
                if (hasFrame == 'true') {
                    $("#sidebar-container").removeClass('d-none');
                    $("#sidebar-container-fullscreen").css('display', 'none');
                }
                videoOrientation.toggleClass('container-video-fullscreen');
            } catch (err) {
                console.log(err.message);
            }
        } else {
            iconFullScreenActive.hide();
            iconFullScreenInactive.show();

            if (bodyID.get(0).requestFullscreen)
                bodyID.get(0).requestFullscreen();
            else if (bodyID.get(0).mozRequestFullScreen)
                bodyID.get(0).mozRequestFullScreen();
            else if (bodyID.get(0).webkitRequestFullscreen)
                bodyID.get(0).webkitRequestFullscreen();
            else if (bodyID.get(0).msRequestFullscreen)
                bodyID.get(0).msRequestFullcreen();

            store.setFullScreen(true);
            $("#sidebar-container").addClass('d-none');
            $("#sidebar-container-fullscreen").attr('style', 'display: block !important');
            videoOrientation.toggleClass('container-video-fullscreen');
        }
    }
}
